import React, { Fragment, useCallback } from 'react'
import styles from './SideBar.module.scss'
import { Divider } from '@mui/material'
import { ReactComponent as Arrow } from '../../assets/icons/side-bar/side-bar-arrow.svg'
import { NavLink } from 'react-router-dom'
import { BOTTOM_SIDE_BAR_ITEMS, TOP_SIDE_BAR_ITEMS } from './sidebarConstants'
import { useDispatch, useSelector } from 'react-redux'
import { logout, setSidebarState } from '../../store/auth/actions'
import { makeSelectUser, sidebarStateSelector } from '../../store/auth/selectors'
import TooltipComponent from '../Shared/Tooltip/TooltipComponent'
import { COLORS } from '../../constants/colors'
import { ReactComponent as LogoGreen } from '../../assets/icons/LogoGreen.svg'

function SideBar() {
  const dispatch = useDispatch()

  const sidebarState = useSelector(sidebarStateSelector())

  const user = useSelector(makeSelectUser())
  const hideMenu = (e) => {
    if (sidebarState === 'hidden') {
      dispatch(setSidebarState('show'))
      localStorage.setItem('sidebar', 'show')
    } else {
      dispatch(setSidebarState('hidden'))
      localStorage.setItem('sidebar', 'hidden')
    }
  }

  const sideItem = (item) => {
    return (
      <div className={styles.sideBarItemDiv}>
        {sidebarState === 'show' ? (
          <Fragment>
            {item.icon}
            <p className={styles.labelText}>{item.title}</p>
          </Fragment>
        ) : (
          <TooltipComponent title={item.title} placement={'right'}>
            {item.icon}
          </TooltipComponent>
        )}
      </div>
    )
  }

  const handleClick = useCallback(
    (val) => {
      localStorage.removeItem('strategyPlanSelectedTab')
      if (val === 'login') {
        dispatch(logout())
      }
    },
    [dispatch],
  )

  return (
    <div className={styles.wrapper} style={{ width: sidebarState === 'hidden' ? '96px' : '260px' }}>
      <div
        className={styles.logoWrapper}
        style={{ justifyContent: sidebarState === 'hidden' ? 'center' : 'flex-start' }}
      >
        {/*<Logo/>*/}
        <LogoGreen color={'#FFFF00'} width={'30px'} height={'30px'} />
        {sidebarState === 'show' && <span className={styles.logoText}>AvoSquado</span>}
        <button
          className={sidebarState === 'hidden' ? styles.arrowButtonHidden : styles.arrowButton}
          onClick={hideMenu}
        >
          <Arrow
            color={COLORS.avoYellow}
            width={sidebarState === 'hidden' ? 12 : 20}
            height={sidebarState === 'hidden' ? 12 : 20}
          />
        </button>
      </div>
      <div className={styles.sideBarWrapper}>
        <div>
          {TOP_SIDE_BAR_ITEMS.filter((item) => {
            if (!item.allowedRoles || item.allowedRoles.length === 0) {
              return true
            }

            return item.allowedRoles.includes(user.role)
          }).map((item, index) => (
            <NavLink
              onClick={() => handleClick(item.path)}
              key={item.id}
              to={item.path ? item.path : '#'}
              style={{
                paddingLeft: sidebarState === 'hidden' ? 20 : 32,
                width: sidebarState === 'hidden' ? 96 : '100%',
                justifyContent: sidebarState === 'hidden' ? 'center' : 'flex-start',
              }}
              className={styles.link}
              activeClassName={item.path ? styles.active : null}
            >
              {sideItem(item)}
            </NavLink>
          ))}
        </div>
        <div style={{ marginBottom: '16px' }}>
          {BOTTOM_SIDE_BAR_ITEMS(user).map((item, index) => {
            return (
              <div key={item.id}>
                {item.isProfile && (
                  <Divider className={styles.dividerStyle} variant="middle" flexItem />
                )}
                <NavLink
                  onClick={() => handleClick(item.path)}
                  to={item.path ? item.path : '#'}
                  style={{
                    paddingLeft: sidebarState === 'hidden' ? 20 : item.isProfile ? 24 : 32,
                    width: sidebarState === 'hidden' ? 96 : '100%',
                    justifyContent: sidebarState === 'hidden' ? 'center' : 'flex-start',
                  }}
                  className={styles.link}
                  activeClassName={item.path ? styles.active : null}
                >
                  {sideItem(item)}
                </NavLink>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SideBar
